export const webhooksTable = {
  header: 'All Webhooks',
  id: 'Webhook ID',
  status: 'Status',
  psp: 'PSP Reference',
  event: 'Event',
  created_at: 'Created Date',
  export: 'Export Webhooks',

  search: 'Search Webhook ID',
};
export const webhookDetails = {
  header1: 'Webhook Request Details: ',

  detailsHeader: 'Webhook Request Details: ',
  rawDataHeader: 'Raw Data',
  error: 'Error',
  log: 'Log',

  id: 'ID',
  status: 'Status',
  external_id: 'PSP Reference',
  event: 'Event',
  created_at: 'Created At',
};
